var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4971 9.25855C14.7092 9.08177 14.7379 8.76649 14.5611 8.55435C14.3843 8.34221 14.069 8.31355 13.8569 8.49033L14.4971 9.25855ZM10.1995 12.189L9.87941 12.5731C10.0648 12.7277 10.3342 12.7277 10.5196 12.5731L10.1995 12.189ZM6.54209 8.49033C6.32995 8.31355 6.01467 8.34221 5.83788 8.55435C5.6611 8.76649 5.68976 9.08177 5.9019 9.25855L6.54209 8.49033ZM14.177 8.87444L13.8569 8.49033L9.87941 11.8049L10.1995 12.189L10.5196 12.5731L14.4971 9.25855L14.177 8.87444ZM10.1995 12.189L10.5196 11.8049L6.54209 8.49033L6.22199 8.87444L5.9019 9.25855L9.87941 12.5731L10.1995 12.189ZM19 10H18.5C18.5 14.6944 14.6944 18.5 10 18.5V19V19.5C15.2467 19.5 19.5 15.2467 19.5 10H19ZM10 19V18.5C5.30558 18.5 1.5 14.6944 1.5 10H1H0.5C0.5 15.2467 4.75329 19.5 10 19.5V19ZM1 10H1.5C1.5 5.30558 5.30558 1.5 10 1.5V1V0.5C4.75329 0.5 0.5 4.75329 0.5 10H1ZM10 1V1.5C14.6944 1.5 18.5 5.30558 18.5 10H19H19.5C19.5 4.75329 15.2467 0.5 10 0.5V1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/CircleArrow.03f75a04accd1e8443cd9a34fbab647b.svg";
export { ForwardRef as ReactComponent };